import { motion } from "framer-motion";
import { CustomButton } from "./sections/Buttons";
import { Link } from "react-router-dom";

const SpeechTherapyPage = () => (
  <motion.div
    className="bg-white"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -30 }}
    transition={{ duration: 0.5, ease: "easeInOut" }}
  >
    {/* Hero Section */}
    <section className="bg-gradient-to-r from-indigo-700 to-purple-600 relative overflow-hidden py-20 text-center">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <svg
          width="900"
          height="400"
          viewBox="0 0 900 400"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full opacity-20"
        >
          <circle cx="450" cy="200" r="200" fill="#fff" fillOpacity="0.07" />
          <circle cx="450" cy="200" r="300" fill="#fff" fillOpacity="0.04" />
        </svg>
      </div>
      <div className="relative z-10 p-4">
        <h1 className="text-5xl font-extrabold mb-2 text-white drop-shadow">
          Speech Language
          <br />
          Therapy
        </h1>
        <div className="text-2xl text-white font-semibold mb-4">
          At Spectrum Nurturing Academy
        </div>
      </div>
    </section>

    {/* Info Card Section */}
    <section className="relative py-16 flex justify-center items-center bg-white">
      {/* Decorative shapes */}
      <div className="hidden md:block absolute left-0 top-0 w-1/3 h-64 -z-10">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <polygon points="0,0 200,0 0,200" fill="#4F46E5" opacity="0.7" />
        </svg>
      </div>
      <div className="hidden md:block absolute right-0 bottom-0 w-1/5 h-40 -z-10">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <circle cx="80" cy="80" r="30" fill="#FBBF24" opacity="0.8" />
        </svg>
      </div>
      <div className="max-w-xl w-full bg-white rounded-xl shadow-2xl p-8 z-10">

      <p className="text-gray-800 text-base mb-4">Communication is key to every aspect of a child’s development. Our licensed Speech and
Language Therapists help children with:</p>


        <ul className="list-disc pl-6 text-gray-800 text-base space-y-3 mb-4">
          <li>Delayed speech or language development.</li>
          <li>Articulation and pronunciation difficulties.</li>
          <li>Expressive and receptive language challenges.</li>
          <li>Social communication and pragmatic skills.</li>
          <li>Augmentative and Alternative Communication (AAC) needs.</li>
        </ul>

        <p className="text-gray-800 text-base mb-0">
          Therapy sessions are personalized to each child’s goals, using engaging activities and strategies to support real-life communication.
        </p>


        {/* <div className="text-gray-700 text-sm flex flex-col gap-1">
          <span className="inline-flex items-center gap-1">
            <span role="img" aria-label="funding">
              🏛️
            </span>{" "}
            Regional Center funding available for children 18mos-36months
          </span>
          <span className="inline-flex items-center gap-1">
            <span role="img" aria-label="insurance">
              🏥
            </span>{" "}
            Kaiser Insurance accepted
          </span>
        </div> */}
      </div>
    </section>

    {/* CTA Section */}
    <section className="flex justify-center items-center py-20 px-2 bg-white">
      <div className="w-full max-w-3xl mx-auto rounded-2xl shadow-xl bg-gradient-to-r from-purple-500 to-pink-400 p-12 text-center">
        <h2 className="text-3xl font-extrabold text-white mb-4">
          Let's Get Started
        </h2>
        <p className="text-white mb-8 text-lg font-medium">
          Contact us today to schedule a free evaluation and tour. Our dedicated
          team is ready to help your child succeed.
        </p>
      
        <div className="flex justify-center mt-6">
          <Link to="/contact">
          <CustomButton
            label="CONTACT US"
            colorClass="text-white bg-black hover:bg-black-500"
          />
        </Link>
        </div>
      </div>
    </section>
  </motion.div>
);

export default SpeechTherapyPage;
